import { useApi } from 'api/api-context';
import NumberStatCard from 'components/stats/NumberStatCard';
import panic from 'errors/panic';
import { useEffect, useState } from 'react';
import { REVISIONS_PAGE_PATH } from 'routes/paths';

/**
 * Displays the number of revisions that have `not-suitable` as the safety point.
 */
export default function RevisionsNotSuitableCard() {
  const { getAction } = useApi();
  const [value, setValue] = useState<number | null>(null);

  useEffect(() => {
    const revisionListAction = getAction('RevisionList');

    revisionListAction({
      query: { filters: { 'safetyPoint.eq': 'not-suitable', 'includedInStatistics.eq': 1, 'kind.eq': 'revision' } },
    })
      .then(({ length }) => setValue(length))
      .catch(panic);
  }, []);

  return (
    <NumberStatCard
      loading={value === null}
      title="Nevyhovujúce revízie"
      link={`${REVISIONS_PAGE_PATH.original}?safetyPoint=not-suitable&kind=revision`}
      value={value ?? 0}
      variant={value === 0 ? 'gray' : 'red'}
    />
  );
}
